export default __webpack_public_path__ + "static/media/socialmedia.21727b13.jpg";